import { useEffect } from "react";
import Navbar from "@/components/luxenova/Navbar";
import Hero from "@/components/luxenova/Hero";
import About from "@/components/luxenova/About";
import Services from "@/components/luxenova/Services";
import Markets from "@/components/luxenova/Markets";
import WhyChoose from "@/components/luxenova/WhyChoose";
import ContactSection from "@/components/luxenova/ContactSection";
import BookingSection from "@/components/luxenova/BookingSection";
import Footer from "@/components/luxenova/Footer";
import ChatbotWidget from "@/components/luxenova/ChatbotWidget";

export default function LuxeNovaHome() {
    useEffect(() => {
        // Reveal-on-scroll observer
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting) e.target.classList.add("in");
                });
            },
            { threshold: 0.15 }
        );
        document.querySelectorAll(".reveal").forEach((el) => io.observe(el));
        return () => io.disconnect();
    }, []);

    return (
        <div data-testid="luxenova-home" className="min-h-screen bg-[#050D1C] text-slate-200">
            <Navbar />
            <main>
                <Hero />
                <About />
                <Services />
                <Markets />
                <WhyChoose />
                <BookingSection />
                <ContactSection />
            </main>
            <Footer />
            <ChatbotWidget />
        </div>
    );
}
